import React, { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import '../designcss/tutorialcss.css';

const DownloadFiles28 = () => {
    const handleDownload = useCallback(() => {
        const files = [
            { href: 'https://gitlab.com/albiemerporte/myecommerceandportfolio2023/-/raw/v1/public/tutorial28/tutorial28.zip?ref_type=heads&inline=false', download: 'tutorial28.zip' }
        ];

        files.forEach(file => {
            const link = document.createElement('a');
            link.href = file.href;
            link.download = file.download;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }, []);

    return (
        <a href="#" onClick={handleDownload}>Download Repository</a>
    );
};

const TutorialTwentyEight= () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Add Adsterra script to head only on this page */}
            {/*<AdScripts />*/}

            <div className="blogcontainer" id="tutorial16">

                <div className="tutorial-banner" onClick={() => window.open("https://www.singlobby.com", "_blank")}>
                    <img src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" />
                </div>

                <div className="card">
                    <h2>How to Use Font Combo Box to Change Font of a Text From Multi Line Text Box Using Qt Designer</h2>

                    <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                        <img 
                            src="https://img.youtube.com/vi/7v-FEg7DUEk/maxresdefault.jpg"
                            alt="Tutorial 28"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>

                    <p style={{ whiteSpace: "pre-wrap" }}>
                    In this comprehensive tutorial, you'll learn how to use a Font Combo Box to change the font of text within a Multi-Line Text Box using Qt Designer. This step-by-step guide will take you through the process, showing you how to easily integrate a font selection feature into your PyQt6 application.
                        <br /><strong>What You'll Learn:</strong>
                        <ul>
                            <li>Setting up a Font Combo Box in Qt Designer</li>
                            <li>Connecting the Font Combo Box to a Multi-Line Text Box to change fonts</li>
                            <li>Writing Python code to handle the font-changing logic</li>
                            <li>Enhancing your GUI’s user experience with dynamic text customization</li>
                        </ul>

                        Ready to elevate your application’s user experience? Watch now and master the art of font customization in PyQt6!
                        <br /><br />
                        #Python #PyQt6 #QtDesigner #FontComboBox #GUI #UserExperience #TextCustomization
                    </p>

                    <button className="seemore">
                        <DownloadFiles28 />
                    </button>
                </div>
            </div><br />
        </>
    );
};

export default TutorialTwentyEight;
